export default __webpack_public_path__ + "static/media/logo-catalogo.6ac4b4c8.png";